import { useBrowserName } from "../Hooks/useBrowserName.tsx";

const BlockBrowsers = ({ children, blockedBrowsers = [] }) => {
  const browserName = useBrowserName();

  if (blockedBrowsers.includes(browserName)) {
    return null;
  }

  return children;
};

export default BlockBrowsers;
